// src/services/UserQuery.api.ts
//
// POSTs the "Discuss Your Campaign" contact form to {BASE_URL}/Campaign/create
// through the shared httpClient. The reCAPTCHA token is verified
// server-side with the secret key.

import axios from "axios";
import httpClient from "./httpClient";
import { UserQueryPayload, SubmitUserQueryResponse } from "../types/userquerymodel";

const DEFAULT_ERROR = "Failed to submit your message. Please try again.";

const extractErrorMessage = (data?: SubmitUserQueryResponse): string | undefined => {
  if (!data) return undefined;
  if (data.message) return data.message;
  if (Array.isArray(data.errors) && data.errors.length) return data.errors[0];
  if (data.errors && typeof data.errors === "object") {
    const first = Object.values(data.errors).flat()[0];
    if (first) return first;
  }
  return undefined;
};

export const submitUserQuery = async (payload: UserQueryPayload): Promise<void> => {
  try {
    const { data } = await httpClient.post<SubmitUserQueryResponse>("/Campaign/create", payload);

    // Only treat it as a failure if the backend explicitly says so.
    if (data && data.success === false) {
      throw new Error(extractErrorMessage(data) || DEFAULT_ERROR);
    }
  } catch (err) {
    if (axios.isAxiosError<SubmitUserQueryResponse>(err)) {
      throw new Error(extractErrorMessage(err.response?.data) || DEFAULT_ERROR);
    }
    throw err;
  }
};